import React from 'react';
import { menu } from './menu_data';
import './menu.css'; // Assuming you have a CSS file for styling

const Menu = () => {
  // Menu updated to match 2025 menu boards
  // TODO: Make it look better on mobile and desktop
  return (
    <div>
      {menu.map(section => (
        <div key={section.id} className="menu-section">
          <h3>{section.name}</h3>
          {section.description && <p className="section-description">{section.description}</p>}
          {section.price && <p className="section-price">{section.price}</p>}
          {section.items &&
            <ul>
              {section.items.map(item => (
                <li key={item.id} className="menu-item">
                  {/* 
                    * TODO: We can use a library like react-image to lazy load them
                    */}
                  <div className="menu-item-image">
                    {item.image ? (
                      <img src={item.image} alt={item.name} />
                    ) : (
                      <div className="placeholder-image">{item.name}</div>
                    )}
                  </div>
                  <div className="menu-item-details">
                    <p><strong>{item.name}</strong></p>
                    <p className="menuItem-description">{item.description}</p>
                    {item.addOns && item.addOns.length > 0 && (
                      <ul className="menuItem-addons">
                        {item.addOns.map((addOn, i) => (
                          <li key={i}>
                            {addOn.name}
                            {addOn.price && <span className="addon-price"> {addOn.price}</span>}
                          </li>
                        ))}
                      </ul>
                    )}
                    {item.options && item.options.length > 0 && (
                      <ul className="menuItem-options">
                        {item.options.map((option, i) => (
                          <li key={i}>
                            <span className="option-label">{option.name}:</span>{' '}
                            {option.choices.join(', ')}
                          </li>
                        ))}
                      </ul>
                    )}
                    <div className="menuItem-price">
                      {item.comboPrice ? (
                        <div className="combo-price-container">
                          <span className="combo-price">
                            <span>COMBO</span>
                            <span>{item.comboPrice}</span>
                          </span>
                          <span className="regular-price">
                            <span>SANDWICH</span>
                            <span className="price">{item.price}</span>
                          </span>
                        </div>
                      ) : (
                        <span>{item.price}</span>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          }
          {section.flavors && (
            <div className="flavor-options">
              {section.flavors.map((flavorGroup, idx) => (
                <div key={idx} className="flavor-group">
                  {flavorGroup.name &&
                    <h4>{flavorGroup.name}</h4>
                  }
                  {flavorGroup.options.some(flavor => typeof flavor !== 'string') ? (
                    <div className="flavors-image-grid">
                      {flavorGroup.options.map((flavor, i) => (
                        <div key={i} className="flavor-image-container">
                          {typeof flavor !== 'string' && flavor.img && (
                            <img 
                              src={flavor.img} 
                              alt={flavor.name || ''} 
                              className="flavor-image" 
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <ul className="flavors-list">
                      {flavorGroup.options.map((flavor, i) => (
                        <li key={i}>{flavor}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
          {section.additionalInfo && (
            <p className="additional-info">{section.additionalInfo}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default Menu;